<template>
  <div>
    <v-layout row wrap style="cursor: pointer" @click.stop.prevent="toogleIcon" v-if="!disabled">
      <v-flex xs1 pa-0 style="display: flex; justify-content: center;">
        <v-icon v-bind:class="{ blue_icon: isSelected, grey_icon: !isSelected }">{{icon}}</v-icon>
      </v-flex>
      <v-flex xs11 py-0>
        <v-container pb-1 pt-2 px-0>
          <v-layout row wrap>
            <slot></slot>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-layout row wrap style="cursor: pointer" @click.stop.prevent="toogleIcon" v-if="disabled">
      <v-flex xs12 py-0>
        <v-container pb-1 pt-2 px-0>
          <v-layout row wrap>
            <slot></slot>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'SelectableListItem',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {}
  },
  computed: {
    icon() {
      return this.isSelected ? 'check_box' : 'check_box_outline_blank'
    }
  },
  methods: {
    toogleIcon() {
      this.$emit('toogle_selected')
    }
  }
}
</script>

<style>
  .v-icon.blue_icon {
    color: #37517e;
  }
  .v-icon.grey_icon {
    color: #CCC;
  }
</style>



// WEBPACK FOOTER //
// src/components/SelectableListItem.vue